import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';

import App from './pages/App';

import 'popper.js/dist/popper';
import 'bootstrap/dist/js/bootstrap.js';

import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/css/all.css';

import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.register();
